import { Autocomplete, TextField, useTheme } from '@mui/material'
import { useEffect, useState } from 'react'
import { useCreateContact } from '../../api/aws/useCreateContact'
import AddRenderOptionButton from '../Contacts/AddRenderOptionButton'
import ContactsDialog from '../Contacts/ContactsDialog'

const OrgBillingContactAutocomplete = ({ options, value, label, onChange, onSetEmail, isDirty }) => {
  const theme = useTheme()
  const [selectedBillingContact, setSelectedBillingContact] = useState(null)
  const [dialogOpen, setDialogOpen] = useState(false)
  const [tempInput, setTempInput] = useState('')
  const [inputValue, setInputValue] = useState('')
  const { mutate: createContact } = useCreateContact()

  useEffect(() => {
    // Set the initial selected contact based on the value prop
    if (value && value.length > 0 && options.length > 0) {
      const initialContact = options.find(contact => contact.contacts_uuid === value[0])
      setSelectedBillingContact(initialContact || null)
    }
  }, [value, options])

  const handleOpenDialog = inputValue => {
    setTempInput(inputValue)
    setDialogOpen(true)
  }

  const handleCloseDialog = () => {
    setDialogOpen(false)
    setTempInput('')
    setInputValue('')
  }

  const handleCreateContacts = newValue => {
    createContact(newValue, {
      onSuccess: data => {
        const newContact = { ...data, contacts_uuid: data.contacts_uuid }
        setSelectedBillingContact(newContact)
        onChange([newContact.contacts_uuid])
        handleCloseDialog()
      },
    })
  }

  const handleSelectExistingContact = (event, newValue) => {
    if (newValue) {
      setSelectedBillingContact(newValue)
      onChange('billingContact', [newValue.contacts_uuid])

      // Set billing email
      if (newValue.email && onSetEmail) {
        onSetEmail('email', newValue.email)
      }
    } else {
      setSelectedBillingContact(null)
      onChange('billingContact', [])
      onSetEmail?.('email', '') // Clear email if contact removed
    }
  }

  return (
    <>
      <Autocomplete
        id="primary-options-autocomplete"
        options={options || []}
        getOptionLabel={option => option.name || ''}
        value={selectedBillingContact}
        onChange={handleSelectExistingContact}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
        filterOptions={(options, { inputValue }) => {
          let filtered = options.filter(option => option.name.toLowerCase().includes(inputValue.toLowerCase()))
          if (inputValue !== '' && !filtered.some(option => option.name.toLowerCase() === inputValue.toLowerCase())) {
            filtered.unshift({ inputValue, specialOption: true, id: `add-new-${inputValue}` })
          }
          return filtered
        }}
        renderOption={(props, option) =>
          option.inputValue ? (
            <AddRenderOptionButton
              key={option.id || `add-new-${option.inputValue}`} // fallback for the custom option
              props={props}
              option={option}
              handleOpenDialog={handleOpenDialog}
            />
          ) : (
            <li {...props} key={option.contacts_uuid}>
              {option.name}
            </li>
          )
        }
        renderInput={params => <TextField {...params} label={label} />}
        fullWidth
        freeSolo
        sx={{
          '& .MuiInputBase-root': {
            bgcolor: isDirty ? theme.palette.text.dirty : theme.palette.background.input,
          },
        }}
      />
      <ContactsDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        tempInput={tempInput}
        onSaveContact={handleCreateContacts}
      />
    </>
  )
}

export default OrgBillingContactAutocomplete
